import { createContext } from 'react';

export interface AuthContextOutput {
  signOut: (props?: { sessionTimeout: boolean }) => Promise<void>;
}

export const AuthContext = createContext<AuthContextOutput>({
  signOut: async () => {}
});
